/* eslint-disable no-magic-numbers */
import { TABLET_WIDTH } from '../constants'
import { WindowSize } from '../helpers/windowSize'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'

export class Leaderboard extends Slot {
  slotName = 'other'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)

    this._sizes = this.adSizes
    this.adUnitId = this.lazy ? 'leaderboard_btf' : 'leaderboard_atf'
  }

  validate(): boolean {
    return (
      super.validate() &&
      WindowSize.width >= TABLET_WIDTH &&
      this.model.leaderboard
    )
  }

  private get adSizes(): AdSizes {
    let sizes: AdSizes =
      WindowSize.width >= 970
        ? [[728, 90], [970, 250], [970, 90], [970, 66]]
        : [[728, 90]]

    if (this.model.leaderboard_atf_disable_billboard) {
      sizes = [[728, 90]]
    }

    return sizes
  }
}
